function unshowLatestSearchSnackbar({ state }) {
  state.set('users.searchOptions.showSnackbar', false)
}

export default unshowLatestSearchSnackbar



// WEBPACK FOOTER //
// ./src/modules/user/actions/unshowLatestSearchSnackbar.js